import AbstractType from "./AbstractType";

export default class NumberType extends AbstractType
{
    static type = "number";

    test = (value) => typeof value === "number";

}